import React from 'react';
import { TaxAddToCartXsellPricing } from './TaxAddToCartXsellPricing';
import { AddToCartXsellPricing } from './AddToCartXsellPricing';
import { AddToCartGetCustomXsellPricing } from './AddToCartGetCustomXsellPricing';

export const XsellPricingInformation = (props) => {
  switch (props.pfid) {
    case 'TAX-01':
    case 'TAX-02':
    case 'TAX-72':
      return <TaxAddToCartXsellPricing {...props} />;

    case 'SPEN-01':
    case 'SSTAMP-01':
    case 'BUNDLE-01':
    case 'BUNDLE-03':
    case 'ENV-08':
      return <AddToCartXsellPricing {...props} />;

    case 'STAMP-19':
    case 'STATE-01':
    case 'INV-01':
    case 'DEP-02':
    case 'DEP-01':
    case 'CHECK-11':
      return <AddToCartGetCustomXsellPricing {...props} />;

    default:
      return <div />;
  }
};
